module.exports = __webpack_public_path__ + "static/media/arrow.c616bc6d.png";